"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _deburr = _interopRequireDefault(require("lodash/deburr"));

var _downshift = _interopRequireDefault(require("downshift"));

var _ListItemText = _interopRequireDefault(require("@eig-builder/core-ui/ListItemText"));

var _MenuItem = _interopRequireDefault(require("@eig-builder/core-ui/MenuItem"));

var _Paper = _interopRequireDefault(require("@eig-builder/core-ui/Paper"));

var _TextField = _interopRequireDefault(require("@eig-builder/core-ui/TextField"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var styles = function styles(theme) {
  return {
    container: {
      flexGrow: 1,
      position: 'relative'
    },
    paper: {
      position: 'absolute',
      zIndex: 1,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0,
      minWidth: 'max-content'
    },
    chip: {
      margin: theme.spacing(0.5, 0.25)
    },
    inputRoot: {
      flexWrap: 'wrap',
      backgroundColor: theme.palette.white.main
    },
    inputInput: {
      width: 'auto',
      flexGrow: 1
    },
    addNew: {
      color: theme.palette.primary.main
    },
    bold: {
      fontWeight: 900
    },
    to: {
      marginRight: theme.spacing(2)
    },
    selected: {
      marginRight: theme.spacing(2),
      lineHeight: '34px'
    }
  };
};

var renderInput = function renderInput(inputProps) {
  var InputProps = inputProps.InputProps,
      classes = inputProps.classes,
      ref = inputProps.ref,
      dataElementSuffix = inputProps.dataElementSuffix,
      other = (0, _objectWithoutProperties2["default"])(inputProps, ["InputProps", "classes", "ref", "dataElementSuffix"]);
  return _react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
    fullWidth: true,
    InputProps: (0, _objectSpread2["default"])({
      inputRef: ref,
      classes: {
        root: classes.inputRoot,
        input: classes.inputInput
      }
    }, InputProps),
    variant: "outlined",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: "control-autocomplete-multiselect-textfield-".concat(dataElementSuffix),
    dataElementId: "control-autocomplete-multiselect-textfield-".concat(dataElementSuffix)
  }, other));
};

renderInput.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object.isRequired,
  InputProps: _propTypes["default"].object
};

var renderSuggestion = function renderSuggestion(suggestionProps) {
  var suggestion = suggestionProps.suggestion,
      index = suggestionProps.index,
      itemProps = suggestionProps.itemProps,
      highlightedIndex = suggestionProps.highlightedIndex,
      selectedItem = suggestionProps.selectedItem,
      classes = suggestionProps.classes,
      dataToLabelsMapping = suggestionProps.dataToLabelsMapping,
      dataElementSuffix = suggestionProps.dataElementSuffix;
  var isHighlighted = highlightedIndex === index;
  var isSelected = (selectedItem || '').indexOf(suggestion.label) > -1;
  var primary = suggestion[dataToLabelsMapping.label] || suggestion[dataToLabelsMapping.secondaryLabel];
  var secondary = suggestion[dataToLabelsMapping.label] ? suggestion[dataToLabelsMapping.secondaryLabel] : '';
  return _react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({}, itemProps, {
    key: secondary || primary,
    selected: isHighlighted,
    component: "div",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: "control-autocomplete-suggestion-".concat(primary, "-").concat(dataElementSuffix),
    dataElementId: "control-autocomplete-suggestion-".concat(primary, "-").concat(dataElementSuffix)
  }), _react["default"].createElement(_ListItemText["default"], {
    classes: {
      primary: "".concat(isSelected ? classes.bold : '', " ").concat(suggestion.addNew ? classes.addNew : '')
    },
    primary: primary,
    secondary: secondary
  }));
};

renderSuggestion.propTypes = {
  highlightedIndex: _propTypes["default"].oneOfType([_propTypes["default"].oneOf([null]), _propTypes["default"].number]).isRequired,
  index: _propTypes["default"].number.isRequired,
  itemProps: _propTypes["default"].object.isRequired,
  selectedItem: _propTypes["default"].string.isRequired,
  suggestion: _propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired
  }).isRequired,
  classes: _propTypes["default"].object.isRequired
};

function getSuggestions(value, suggestions) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$creatable = _ref.creatable,
      creatable = _ref$creatable === void 0 ? false : _ref$creatable,
      dataToLabelsMapping = _ref.dataToLabelsMapping,
      _ref$showEmpty = _ref.showEmpty,
      showEmpty = _ref$showEmpty === void 0 ? false : _ref$showEmpty,
      creatableValidator = _ref.creatableValidator,
      creatableLabelTextFormatter = _ref.creatableLabelTextFormatter;

  var inputValue = (0, _deburr["default"])(value.trim()).toLowerCase();
  var inputLength = inputValue.length;
  var count = 0;
  var filtered = inputLength === 0 && !showEmpty ? [] : suggestions.filter(function (suggestion) {
    var label = suggestion[dataToLabelsMapping.label];
    var secondaryLabel = suggestion[dataToLabelsMapping.secondaryLabel];
    var keep = count < 5 && (label && label.slice(0, inputLength).toLowerCase() === inputValue || secondaryLabel && secondaryLabel.slice(0, inputLength).toLowerCase() === inputValue);

    if (keep) {
      count += 1;
    }

    return keep;
  });

  if (creatableValidator && creatableValidator(inputValue) && !filtered.length && creatable) {
    return [{
      name: creatableLabelTextFormatter(inputValue),
      addNew: true
    }];
  }

  return filtered;
}

var DownshiftAutocomplete = function DownshiftAutocomplete(props) {
  var classes = props.classes,
      dataElementSuffix = props.dataElementSuffix,
      label = props.label,
      onSelectionChange = props.onSelectionChange,
      placeholder = props.placeholder,
      selectedSuggestions = props.selectedSuggestions,
      suggestions = props.suggestions,
      dataToLabelsMapping = props.dataToLabelsMapping,
      onCreateNew = props.onCreateNew,
      itemToString = props.itemToString,
      prefix = props.prefix,
      creatableValidator = props.creatableValidator,
      creatableLabelTextFormatter = props.creatableLabelTextFormatter;

  var _React$useState = _react["default"].useState(''),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      inputValue = _React$useState2[0],
      setInputValue = _React$useState2[1];

  (0, _react.useEffect)(function () {
    var selected = (0, _toConsumableArray2["default"])(selectedSuggestions);
    var addedNewTemp = selected.find(function (i) {
      return i.addNew;
    });
    var addedNew = addedNewTemp && suggestions.find(function (s) {
      return itemToString(s) === itemToString(addedNewTemp);
    });

    if (addedNewTemp && addedNew) {
      var addedNewTempIndex = selected.map(itemToString).indexOf(itemToString(addedNewTemp));
      selected.splice(addedNewTempIndex, 1, addedNew);
      onSelectionChange(selected);
    }
  }, [suggestions.length, selectedSuggestions.length]);

  var handleKeyDown = function handleKeyDown(event) {
    if (selectedSuggestions.length && !inputValue.length && event.key === 'Backspace') {
      onSelectionChange(selectedSuggestions.slice(0, selectedSuggestions.length - 1));
    }
  };

  var handleInputChange = function handleInputChange(event) {
    setInputValue(event.target.value);
  };

  var handleChange = function handleChange(item) {
    if (item) {
      var newSelectedItems = (0, _toConsumableArray2["default"])(selectedSuggestions);

      if (item.addNew) {
        onCreateNew && onCreateNew(inputValue);
        newSelectedItems = [].concat((0, _toConsumableArray2["default"])(newSelectedItems), [{
          email_address: inputValue,
          addNew: true,
          type: 'contact'
        }]);
      } else if (!newSelectedItems.find(function (i) {
        return i.id === item.id;
      })) {
        newSelectedItems = [].concat((0, _toConsumableArray2["default"])(newSelectedItems), [item]);
      }

      setInputValue('');
      onSelectionChange(newSelectedItems);
    }
  };

  return _react["default"].createElement(_downshift["default"], {
    id: "downshift-multiple-test",
    inputValue: inputValue,
    itemToString: itemToString,
    onChange: handleChange,
    selectedItem: selectedSuggestions,
    defaultHighlightedIndex: 0
  }, function (_ref2) {
    var getInputProps = _ref2.getInputProps,
        getItemProps = _ref2.getItemProps,
        getLabelProps = _ref2.getLabelProps,
        isOpen = _ref2.isOpen,
        openMenu = _ref2.openMenu,
        inputValue = _ref2.inputValue,
        selectedItem = _ref2.selectedItem,
        highlightedIndex = _ref2.highlightedIndex;

    var _getInputProps = getInputProps({
      onKeyDown: handleKeyDown,
      placeholder: placeholder,
      onFocus: openMenu
    }),
        onBlur = _getInputProps.onBlur,
        _onChange = _getInputProps.onChange,
        onFocus = _getInputProps.onFocus,
        inputProps = (0, _objectWithoutProperties2["default"])(_getInputProps, ["onBlur", "onChange", "onFocus"]);

    return _react["default"].createElement("div", {
      className: classes.container
    }, renderInput({
      fullWidth: true,
      classes: classes,
      label: label,
      InputLabelProps: getLabelProps(),
      InputProps: {
        startAdornment: _react["default"].createElement(_react["default"].Fragment, null, prefix, selectedItem.map(function (item) {
          var textValue = itemToString(item);
          return _react["default"].createElement("div", {
            key: textValue,
            className: classes.selected
          }, textValue, ",");
        })),
        onBlur: onBlur,
        onChange: function onChange(event) {
          handleInputChange(event);

          _onChange(event);
        },
        onFocus: onFocus
      },
      inputProps: inputProps,
      dataElementSuffix: dataElementSuffix
    }), isOpen ? _react["default"].createElement(_Paper["default"], {
      className: classes.paper,
      square: true
    }, getSuggestions(inputValue, suggestions, {
      creatable: !!onCreateNew,
      dataToLabelsMapping: dataToLabelsMapping,
      showEmpty: true,
      creatableValidator: creatableValidator,
      creatableLabelTextFormatter: creatableLabelTextFormatter
    }).map(function (suggestion, index) {
      return renderSuggestion({
        suggestion: suggestion,
        index: index,
        itemProps: getItemProps({
          item: suggestion
        }),
        highlightedIndex: highlightedIndex,
        selectedItem: selectedItem,
        classes: classes,
        dataToLabelsMapping: dataToLabelsMapping,
        dataElementSuffix: dataElementSuffix
      });
    })) : null);
  });
};

DownshiftAutocomplete.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  dataElementSuffix: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  onSelectionChange: _propTypes["default"].func.isRequired,
  placeholder: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  selectedSuggestions: _propTypes["default"].array,
  suggestions: _propTypes["default"].array.isRequired,
  onCreateNew: _propTypes["default"].func,
  dataToLabelsMapping: _propTypes["default"].object.isRequired,
  itemToString: _propTypes["default"].func.isRequired,
  prefix: _propTypes["default"].node,
  creatableValidator: _propTypes["default"].func,
  creatableLabelTextFormatter: _propTypes["default"].func
};
DownshiftAutocomplete.defaultProps = {
  dataToLabelsMapping: {
    label: 'name',
    secondaryLabel: 'email_address'
  },
  itemToString: function itemToString(item) {
    return item.type === 'contact' ? item.email_address : item.name;
  }
};

var _default = (0, _styles.withStyles)(styles)(DownshiftAutocomplete);

exports["default"] = _default;